module.exports = __webpack_public_path__ + "img/img-applanding.af255ad0.png";